import { render } from "./SpentsList.vue?vue&type=template&id=297d5089&ts=true"
import script from "./SpentsList.vue?vue&type=script&lang=ts"
export * from "./SpentsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__